import { MetaMask } from '@/connect/wallet/metaMask'
import { WalletConnect } from '@/connect/wallet/walletConnect'
import { Ledger } from '@/connect/wallet/ledger'
import { Trezor } from '@/connect/wallet/trezor'

export { MetaMask, WalletConnect, Ledger, Trezor }

export default {
  MetaMask,
  WalletConnect,
  Ledger,
  Trezor
}
